// ScrollToTopOnRouteChange.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    // Small timeout to ensure DOM is ready, then scroll to top
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;